import { ethers } from 'ethers';
import { CryptoClickerContract } from './types';

export const CRYPTO_CLICKER_ADDRESS = import.meta.env.VITE_CONTRACT_ADDRESS || '0xa657862Ecc9110597b888152f9de45c441eb8cb2';

export const CRYPTO_CLICKER_ABI = [
  {
    "inputs": [],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "inputs": [],
    "name": "admin",
    "outputs": [{"internalType": "address", "name": "", "type": "address"}],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "adminWithdraw",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [{"internalType": "uint256", "name": "clicks", "type": "uint256"}],
    "name": "registerClicks",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [{"internalType": "uint256", "name": "coinsAmount", "type": "uint256"}],
    "name": "withdraw",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "minimumWithdrawal",
    "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "maximumWithdrawal",
    "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "maxWithdrawalPerDay",
    "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "maxWithdrawalPerWeek",
    "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "maxWithdrawalPerMonth",
    "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "maxMultiplierPurchase",
    "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "maxAutoClickerPurchase",
    "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "coinsPerWei",
    "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "clicksPerMiningCycle",
    "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "weiPerMiningCycle",
    "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {"internalType": "uint256", "name": "_minimumWithdrawal", "type": "uint256"},
      {"internalType": "uint256", "name": "_maximumWithdrawal", "type": "uint256"},
      {"internalType": "uint256", "name": "_maxWithdrawalPerDay", "type": "uint256"},
      {"internalType": "uint256", "name": "_maxWithdrawalPerWeek", "type": "uint256"},
      {"internalType": "uint256", "name": "_maxWithdrawalPerMonth", "type": "uint256"}
    ],
    "name": "updateWithdrawalLimits",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {"internalType": "uint256", "name": "_maxMultiplierPurchase", "type": "uint256"},
      {"internalType": "uint256", "name": "_maxAutoClickerPurchase", "type": "uint256"}
    ],
    "name": "updatePurchaseLimits",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [{"internalType": "uint256", "name": "_coinsPerWei", "type": "uint256"}],
    "name": "updateConversionRate",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {"internalType": "uint256", "name": "_clicksPerMiningCycle", "type": "uint256"},
      {"internalType": "uint256", "name": "_weiPerMiningCycle", "type": "uint256"}
    ],
    "name": "updateMiningRates",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [{"internalType": "address", "name": "user", "type": "address"}],
    "name": "getMiningStats",
    "outputs": [
      {"internalType": "uint256", "name": "currentClicks", "type": "uint256"},
      {"internalType": "uint256", "name": "pendingWei", "type": "uint256"},
      {"internalType": "uint256", "name": "clicksNeededForNextCycle", "type": "uint256"}
    ],
    "stateMutability": "view",
    "type": "function"
  }
];

export function getContract(provider: ethers.BrowserProvider, signer: ethers.JsonRpcSigner | null): CryptoClickerContract {
  if (!provider || !signer) {
    throw new Error('Provider and signer are required');
  }
  
  if (!CRYPTO_CLICKER_ADDRESS) {
    throw new Error('Contract address is not defined');
  }

  try {
    return new ethers.Contract(
      CRYPTO_CLICKER_ADDRESS,
      CRYPTO_CLICKER_ABI,
      signer
    ) as CryptoClickerContract;
  } catch (error) {
    console.error('Error creating contract instance:', error);
    throw error;
  }
}